import { useCallback, useRef } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useDebouncedCallback<T extends (...args: any[]) => any>(
  wait: number,
  callback: T,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dependencies: any[] = [],
): T {
  const timeout = useRef<ReturnType<typeof setTimeout>>()

  return useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args: any[]) => {
      const later = () => {
        clearTimeout(timeout.current)
        callback(...args)
      }

      clearTimeout(timeout.current)
      timeout.current = setTimeout(later, wait)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [callback, wait, ...dependencies],
  ) as T
}
